// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

export const LOGIN_URL  = `/api/login`;
export const LOGOUT_URL = `/api/logout`;

export const GET_FORM_URL               = (id: string) => `/api/forms/${q(id)}`;
export const SUBMIT_FORM_URL            = (id: string) => `/api/forms/${q(id)}`;

export const CREATE_FORM_URL            = `/api/edit/forms`;
export const LIST_FORMS_FOR_EDITING_URL = `/api/edit/forms`;
export const GET_FORM_FOR_EDITING_URL   = (id: string) => `/api/edit/forms/${q(id)}`;
export const UPDATE_FORM_URL            = (id: string) => `/api/edit/forms/${q(id)}`;
export const DELETE_FORM_URL            = (id: string) => `/api/edit/forms/${q(id)}`;

export const LIST_FORM_VALUES_URL       = (id: string) => `/api/edit/forms/${q(id)}/entries`;
export const GET_FORM_VALUE_URL         = (id: string, entryId: string) => `/api/edit/forms/${q(id)}/entries/${q(entryId)}`;

export const CREATE_PIPELINE_URL             = `/api/edit/pipelines`;
export const LIST_PIPELINES_URL              = `/api/edit/pipelines`;
export const GET_PIPELINE_URL                = (id: string) => `/api/edit/pipelines/${q(id)}`;
export const UPDATE_PIPELINE_URL             = (id: string) => `/api/edit/pipelines/${q(id)}`;
export const DELETE_PIPELINE_URL             = (id: string) => `/api/edit/pipelines/${q(id)}`;

export const LIST_PIPELINE_RUNS_URL          = (id: string) => `/api/edit/pipelines/${q(id)}/runs`;
export const GET_PIPELINE_RUN_URL            = (id: string, runId: string, long : number | undefined = undefined) => `/api/edit/pipelines/${q(id)}/runs/${q(runId)}${ long !== undefined ? `?poll=${long}` : ''}`;

export const CREATE_AGENT_POOL_URL             = `/api/edit/agents`;
export const LIST_AGENT_POOLS_URL              = `/api/edit/agents`;
export const GET_AGENT_POOL_URL                = (id: string) => `/api/edit/agents/${q(id)}`;
export const UPDATE_AGENT_POOL_URL             = (id: string) => `/api/edit/agents/${q(id)}`;
export const DELETE_AGENT_POOL_URL             = (id: string) => `/api/edit/agents/${q(id)}`;

export const CREATE_AGENT_ACCOUNT_URL          = (id: string) => `/api/edit/agents/${q(id)}/members`;

function q (value: string) : string {
    return encodeURIComponent(value);
}
